export enum ShiftBreakType {
  LUNCH_TIME = "lunch_time",
  DOWN_TIME = "down_time",
}
